import LabelProvider from "core/components/label/LabelProvider";

export default LabelProvider.create({
	CompletionStatus: {
			k: "programStatus.completed",
			v: "${Completed} of ${Total} topics",
			argNames: ['Completed', 'Total']
	},
	PreTest: {
			k: "programStatus.preTest",
			v: "1. Pre-Test"
	},
	StudyPractice: {
			k: "programStatus.tracks",
			v: "Study & Practice"
	},
	PostTest: {
			k: "programStatus.postTest",
			v: "3. Post-Test"
	}
});



// WEBPACK FOOTER //
// ./src/panels/programStatus/ProgramStatus.labels.ts